/**
 * FAI Login Custom Events
 */
export const FAILoginRegistrationCustomEvents = {
  LOGGED_IN: 'fai-user-login',
  LOGGED_OUT: 'fai-user-logout',
  OPEN_LOGIN_OVERLAY: 'fai-user-open-login-overlay',
  OPEN_REGISTRATION_OVERLAY: 'fai-user-open-registration-overlay',
  HIDE_REGISTRATION_OVERLAY: 'fai-user-hide-registration-overlay',
  OPEN_REGISTRATION_COMPLETE_OVERLAY:
    'fai-user-open-registration-complete-overlay',
  SWITCH_TO_LOGIN_TAB: 'fai-user-login-overlay-login-tab',
  SWITCH_TO_REGISTER_TAB: 'fai-user-login-overlay-register-tab',
  ACTIVATE_REGISTRATION_EMAIL: 'fai-user-activate-registration-email',
  ACTIVATE_UPDATED_EMAIL: 'fai-user-activate-updated-email',
  USER_ACTIVATED_FROM_EMAIL: 'fai-user-activated-from-email',
} as const;
